import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import store from "../reducers/createReducers";
import GLOBAL_ACTIONS from "../actions/global-actions";
import {useSelector} from "react-redux";
import {decrypt, encrypt} from "../helpers/encryption";
import AUTHENTICATION_ACTIONS from "../actions/authentication-actions";
import SESSION_HELPER from "../helpers/session-helper";
import {useTranslation} from "react-i18next";
import associateServices from "../services";
import SvgIcon from "../components/svg-icon";
import Loading from "../components/loading";
import stringHelper from "../helpers/string-helper";

const MainListeners = () => {

    const {t} = useTranslation()
    const {displayCryptoInFiat, authenticated, selectedFiat} = useSelector(state => state.authenticationReducer)
    const location = useLocation()
    const {activeLanguage, agent} = useSelector(state => state.globalReducer)

    useEffect(() => {
        window?.addEventListener("resize", () => {
            const agent = SESSION_HELPER.getUserAgent()
            store.dispatch(GLOBAL_ACTIONS.setUserAgent(agent))
        });
        return () => {
            window.removeEventListener("resize", () => {
                const agent = SESSION_HELPER.getUserAgent()
                store.dispatch(GLOBAL_ACTIONS.setUserAgent(agent))
            })
        }
    }, []);
    useEffect(() => {
        if (authenticated) {
            const bdy = document.body
            bdy?.classList?.add('logged-in')

            return () => bdy?.classList?.remove('logged-in')
        }

    }, [authenticated]);

    useEffect(() => {
        const agent = SESSION_HELPER.getUserAgent()
        store.dispatch(GLOBAL_ACTIONS.setUserAgent(agent))
    }, [])

    const handleFiatRates = e => {
        store.dispatch(AUTHENTICATION_ACTIONS.setFiatRatesAction(decrypt(e)))
    }

    useEffect(() => {

        if (displayCryptoInFiat && selectedFiat) {
            window?.tcpSocket?.emit('fiat:rate', encrypt({
                currency: selectedFiat
            }))

            window?.tcpSocket?.on('fiat:rates', handleFiatRates)
        }
    }, [displayCryptoInFiat, selectedFiat, window?.tcpSocket?.connected])

    useEffect(() => {
        if (agent.isMobile) {
            const sidebar = document.getElementById('sidebar')
            const main = document.getElementById('main')
            sidebar?.classList?.remove('active')
            main?.classList?.remove('main--active')
        }


    }, [location?.pathname, agent.isMobile])


    useEffect(() => {
        const modalExits = getParams('modal')
        if (modalExits) {
            checkForModal(modalExits)
        } else {
            const bdy = document.body
            bdy.classList?.remove('modal-open')
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
        }

    }, [location.search])
    const getParams = (key) => {
        const searchParams = new URLSearchParams(location?.search);
        return searchParams.get(key);
    }
    const checkForModal = modalType => {
        if (modalType === 'wallet') {

            let tab = getParams('tab')
            if (!['deposit', 'swap', 'withdraw', 'buy-crypto', 'tip', 'rakeback', 'reload', 'discount'].includes(tab))
                tab = 'deposit'
            store.dispatch(GLOBAL_ACTIONS.setModalTabAction(tab))

            const currency = getParams('currency')
            store.dispatch(GLOBAL_ACTIONS.setModalCurrencyAction(currency))
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction('wallet'))
            // handleWalletModalSettings()
        } else if (modalType === 'vip') {

            let tab = getParams('tab')
            if (!['progress', 'benefits', 'bonus-code', 'boost', 'rakeback', 'reload', 'bonus', 'correction'].includes(tab))
                tab = 'progress'
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(modalType))

            store.dispatch(GLOBAL_ACTIONS.setModalTabAction(tab))
        } else if (modalType === 'bonus-request') {
            let tab = getParams('tab')
            if (!['all', 'deposit-bonuses', 'welcome-bonuses', 'auto-bonuses', 'bonus-drops', 'discount-settings'].includes(tab))
                tab = 'progress'

            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(modalType))
            store.dispatch(GLOBAL_ACTIONS.setModalTabAction(tab))
        } else if (modalType === 'vault') {

            let tab = getParams('tab')
            if (!['deposit', 'withdraw'].includes(tab))
                tab = 'deposit'
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(modalType))

            store.dispatch(GLOBAL_ACTIONS.setModalTabAction(tab))

            const currency = getParams('currency')
            if (currency)
                store.dispatch(GLOBAL_ACTIONS.setModalCurrencyAction(currency))


        } else if (modalType === 'statistics') {
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(modalType))

            let tab = getParams('tab')
            if (!['statistics', 'trophy', 'races', 'raffles'].includes(tab))
                tab = 'statistics'


            store.dispatch(GLOBAL_ACTIONS.setModalTabAction(tab))

        } else if (modalType === 'bet') {
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(modalType))
            let tab = getParams('reference')
            store.dispatch(GLOBAL_ACTIONS.setModalTabAction(tab))
        } else if (modalType === 'bonus-detail') {
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(modalType))
        } else if (modalType === 'rain') {
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(modalType))
        } else if (
            modalType === 'register' ||
            modalType === 'login' ||
            modalType === 'forgot-password' ||
            modalType === 'raffle' ||
            modalType === 'wallet-settings' ||
            // modalType === 'wheel' ||
            modalType === 'unify-balances' ||
            modalType === 'bets' ||
            modalType === 'tip' ||
            modalType === 'wheel-prize' ||
            modalType === 'race' || modalType === 'campaign') {
            store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(modalType))
        }

    }


    const [fetched, setFetched] = useState(false)
    const [modal, setModal] = useState(null)
    const [modals, setModals] = useState(null)
    const checkModal = () => {
        associateServices.checkModal({
            lang: activeLanguage?.key,
            device: agent?.isMobile ? 'mobile' : 'web'
        }).then(res => {
            if (res?.data) {

                if (res?.data?.length >= 1)
                    setModal(res?.data[0])

                setModals(res?.data || [])
            }

            setFetched(true)
        })

    }

    useEffect(() => {
        // console.log('agent = ', agent)
        if (activeLanguage?.key && agent?.width && !fetched)
            checkModal()

    }, [agent?.isMobile, activeLanguage?.key, fetched])


    useEffect(() => {
        if (modals?.length >= 1) {


            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('global-modal')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.9)'

            return () => {
                const bdy = document.body
                bdy.classList?.remove('modal-open')

                const mdl = document.getElementById('global-modal')
                mdl.classList?.remove('show')

                mdl.style.display = 'none'
                mdl.style.backgroundColor = 'rgba(0,0,0,.9)'
            }
        }

    }, [modals])

    const handleClose = () => {


        const nextModal = modals?.find(pp => pp?.id > modal?.id)

        console.log('nextModal = ', nextModal)
        if (nextModal)
            setModal(nextModal)
        else {
            // const bdy = document.body
            // bdy.classList?.remove('modal-open')
            // store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
            // setModal(null)

            const bdy = document.body
            bdy.classList?.remove('modal-open')

            const mdl = document.getElementById('global-modal')
            mdl.classList?.remove('show')

            mdl.style.display = 'none'
            mdl.style.backgroundColor = 'rgba(0,0,0,.9)'

            setHidden(true)
        }
    }
    const {i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language
    const navigate = useNavigate()
    const handleCheckNavigation = () => {
        if (!modal?.link)
            return false;

        if (modal?.link?.startsWith('/') || modal?.link?.startsWith('?'))
            // return navigate(modal?.link)
            return navigate(stringHelper.getLocalizedPath(currentLanguage, modal?.link))


        window.open(modal?.link, '_blank')
    }

    const handleIgnore = () => {
        setModal(null)
        associateServices.ignoreModal({
            id: modal.id,
        }).then(res => {

        })
    }

    const [loaded, setLoaded] = useState(false)
    const [hidden, setHidden] = useState(false)

    if (hidden)
        return null;
    return (
        <div
            className={`modal  ${modal?.type === 'image' ? 'modal--img' : ''} fade`}
            id="global-modal"
            tabIndex={-1}
            aria-labelledby="global-modal"
            aria-hidden="true"
            onClick={handleClose}

        >


            <div className="modal-dialog  modal-dialog-centered" onClick={e => e.preventDefault()}>
                <div className="modal-content">
                    <div className="modal__head">
                        {
                            authenticated ?
                                <span onClick={handleIgnore} className="p-2">
                                {t('general.dont-show-again')}
                            </span> :
                                <span/>
                        }
                        <button className="modal__close"
                                type="button" onClick={handleClose}>
                            <SvgIcon id={'x'}/>
                        </button>
                    </div>
                    {
                        modal?.type === 'image' ?
                            // <img
                            //     onClick={handleCheckNavigation}
                            //     src={'https://vendor-provider.fra1.digitaloceanspaces.com/ebetlab/qwVpcjhJhjJbbJXthDaTicFGPdhWnmjf/modalItems/Y4tHGPZfd4geJ6HUtR9aJxFGIVVRbx1lzpNzmvKh.png'}
                            //     alt=""/>
                            <>


                                <img
                                    onClick={handleCheckNavigation}
                                    className="modal__img" src={modal?.image}
                                    alt=""
                                    onLoad={e => setLoaded(true)}
                                />

                                {
                                    !loaded && <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minHeight: 180,
                                        backgroundColor: 'var(--tf-bg)'
                                    }}>
                                        <Loading/>
                                    </div>
                                }

                            </>

                            :

                            <div className="modal__scrollable">
                                <div
                                    onClick={handleCheckNavigation}
                                    dangerouslySetInnerHTML={{__html: modal?.content}}/>
                            </div>

                    }

                </div>
            </div>

        </div>

    )
}


export default MainListeners
